import React, { useState } from 'react';
import {
	Analysis,
	CardWrapper,
	ContentWrapper,
	ExploreButton,
	Heading,
	IconWrapper,
	RiskWrapper,
	SubWrapper,
	Wrapper,
} from './Cards.styles';
import { ApIcon, ApLoaderDefault } from '@alixpartners/ui-components';
import { InsightsType } from 'CategoryManagement/utils';
import { cardColorDefault, iconColor } from './utils';
import ExploreModal from 'CategoryManagement/Explore/ExploreModal';
import { useCommonVendorsContext } from 'contexts/CategoryInsightsKpi/CommonVendorsProvider';
import { useCommonSuppliersContext } from 'contexts/CategoryInsightsKpi/CommonSupplierProvider';
import CommonSupplierByBU from 'CategoryManagement/Explore/DetailedAnalysis/CommonSupplierByBU';

const CommonVendors = ({ name }) => {
	const { isLoading, analysis, gridData } = useCommonVendorsContext();
	const [isExplore, setIsExplore] = useState(false);
	const { isLoading: commonSuppliersLoading } = useCommonSuppliersContext();
	return (
		<>
			<Wrapper>
				<SubWrapper>
					<RiskWrapper tileColor={cardColorDefault} />
					<CardWrapper>
						<IconWrapper iconColor={iconColor}>
							<div>
								<ApIcon
									material={true}
									iconName={InsightsType[1].iconName}
									iconSize={20}
								/>
							</div>
							<div>
								{!isLoading &&
									!commonSuppliersLoading &&
									gridData.rowData.length > 0 && (
										<ExploreButton
											title="Explore"
											className="explore"
											onClick={() => setIsExplore(true)}
										>
											<ApIcon
												title="Explore"
												material={true}
												iconName="find_in_page"
											/>
										</ExploreButton>
									)}
							</div>
						</IconWrapper>
						{isLoading || commonSuppliersLoading ? (
							<ApLoaderDefault />
						) : (
							<ContentWrapper>
								<Heading>{name}</Heading>
								<Analysis>{analysis}</Analysis>
							</ContentWrapper>
						)}
					</CardWrapper>
				</SubWrapper>
			</Wrapper>
			{isExplore && (
				<ExploreModal title={name} onClose={setIsExplore}>
					<CommonSupplierByBU />
				</ExploreModal>
			)}
		</>
	);
};

export default CommonVendors;
